import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Link,
  Text
} from '@chakra-ui/react';
import MainLayout from 'components/layouts/MainLayout';
import { openWindow } from 'libs/line';
import { tenantConfigurationAtom } from 'libs/recoil/atom';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { LINK_FORM_PAGE_PATH } from './LinkFormPage';

export const LINK_PAGE_PATH = '/smart-receipt';

export const LinkPage: FC = () => {
  const tenantConfig = useRecoilValue(tenantConfigurationAtom);
  const navigate = useNavigate();

  const handleLinking = () => {
    navigate(LINK_FORM_PAGE_PATH);
  };

  const handleGoToSignUpSite = () => {
    if (tenantConfig.smart_receipt?.sign_up_url) {
      openWindow(tenantConfig.smart_receipt.sign_up_url);
    }
  };

  const handleGoBack = () => {
    navigate('/membership');
  };

  return (
    <MainLayout
      pageTitle="スマートレシート連携の前に"
      bg="dark.50"
      header
      footer
    >
      <Container px="1rem" pt="2.25rem">
        <Flex direction="column" align="center" justify="center">
          <Heading
            as="h1"
            size="lg"
            textAlign="center"
            mt={3}
            mb={4}
            color="gray.700"
          >
            スマートレシート連携の前に
          </Heading>

          <Text fontSize="1rem" lineHeight="1.5" color="gray.600" mb={8}>
            「スマートレシート ®」
            は東芝テック株式会社が提供する電子レシートサービスです。
          </Text>

          <Box mb={12} width="100%" maxWidth="400px">
            <Heading
              as="h2"
              size="2rem"
              textAlign="left"
              color="gray.600"
              mb={2}
            >
              スマートレシートのアカウントを持っている
            </Heading>
            <Text fontSize="1rem" lineHeight="1.5" color="gray.600" mb={4}>
              下記の連携ボタンから、会員番号の連携フォームに進んでください。
            </Text>
            <Heading
              as="h2"
              size="2rem"
              textAlign="left"
              color="gray.600"
              mb={2}
            >
              スマートレシートのアカウントを持っていない
            </Heading>
            <Text fontSize="1rem" lineHeight="1.5" color="gray.600" mb={2}>
              スマートレシートのサイトでアカウントの作成を行ってください。
            </Text>
            <Link
              fontSize="md"
              textAlign="center"
              fontWeight="bold"
              color="blue.500"
              textDecoration="underline"
              onClick={handleGoToSignUpSite}
              cursor="pointer"
            >
              スマートレシートのアカウント作成はこちら
            </Link>
          </Box>

          <Box width="100%" maxWidth="400px">
            <Button
              mb={6}
              variant="primary-fullwidth-rounded"
              onClick={handleLinking}
            >
              スマートレシートアカウントを連携する
            </Button>
            <Button
              variant="primary-outline-fullwidth-rounded"
              onClick={handleGoBack}
            >
              戻る
            </Button>
          </Box>
        </Flex>
      </Container>
    </MainLayout>
  );
};
